import { ActionReducer } from '@ngrx/store';
import { InjectionToken, Type } from '@angular/core';
export class StoreDevtoolsConfig {
  maxAge: number | false;
  monitor: ActionReducer<any, any>;
}

function StoreDevtoolsConfig_tsickle_Closure_declarations() {
/** @type {?} */
StoreDevtoolsConfig.prototype.maxAge;
/** @type {?} */
StoreDevtoolsConfig.prototype.monitor;
}


export const /** @type {?} */ STORE_DEVTOOLS_CONFIG = new InjectionToken<StoreDevtoolsConfig>(
  '@ngrx/devtools Options'
);
export const /** @type {?} */ INITIAL_OPTIONS = new InjectionToken<StoreDevtoolsConfig>(
  '@ngrx/devtools Initial Config'
);

export type StoreDevtoolsOptions =
  | Partial<StoreDevtoolsConfig>
  | (() => Partial<StoreDevtoolsConfig>);



// WEBPACK FOOTER //
// ../../../modules/store-devtools/src/config.ts